module.exports = __webpack_public_path__ + "static/media/process_med.be92ee5e.jpg";